<div class="doc-notification warning" *ngIf="location === 'personalDetails'; else twoFAHeader">
  <span class="icon-i-warning"></span>
  <p>
    {{ 'account.summary.section.mobilePhoneValidation.warning' | translate }}
  </p>
</div>
<ng-template #twoFAHeader>
  <a class="back-btn" (click)="goBack()">{{ 'general.back' | translate }}</a>
  <h3 class="ui-headline">{{ (enabled2FA ? '2fa.disable.title' : '2fa.enable.title') | translate }}</h3>
</ng-template>
<p>{{ '2fa.code.p' | translate: { phoneNumber: phoneNumber } }}</p>
<form [formGroup]="verifyForm">
  <div class="code-wrapper">
    <div class="input-boxes">
      <span
        *ngFor="let item of [0, 1, 2, 3, 4, 5]"
        [class.active]="verifyCodeInput.value[item]"
        [class.focus]="item === 0 ? true : verifyCodeInput.value[item - 1]"
        >{{ verifyCodeInput.value[item] }}</span
      >
    </div>
    <input #verifyCodeInput class="code-input" autocomplete="one-time-code" min="0" type="tel" formControlName="code" />
  </div>
</form>
<!-- Footer actions -->
<div *ngIf="location === 'personalDetails'">
  <a (click)="resendCode()">{{ '2fa.code.resend' | translate }}</a>
</div>
<div *ngIf="location === '2FA'" class="action-links">
  <a (click)="resendCode()">{{ '2fa.code.resend' | translate }}</a> ·
  <a *ngIf="!enabled2FA" (click)="changeScreen('phone')">{{ '2fa.phone_setup.changePhone' | translate }}</a>
  <span *ngIf="!enabled2FA"> · </span>
  <a (click)="changeScreen('help')">{{ '2fa.code.needHelp' | translate }}</a>
</div>
